import { Google, UniversalSocialauth } from 'universal-social-auth'
import axios from 'axios'
import { ProderT } from 'universal-social-auth/dist/providers'

const microsoftProvider: Record<string, unknown> = {
  name: 'microsoft',
  authorizationEndpoint: 'https://login.microsoftonline.com/common/oauth2/v2.0/authorize',
  redirectUri: window.location.origin,
  requiredUrlParams: ['scope'],
  optionalUrlParams: ['display'],
  responseMode: ['form_post'],
  scope: ['User.Read'], // https://msdn.microsoft.com/en-us/library/azure/ad/graph/howto/azure-ad-graph-api-permission-scopes.
  scopePrefix: 'openid',
  scopeDelimiter: ' ',
  display: 'popup',
  oauthType: '2.0',
  popupOptions: { width: 580, height: 400 },
}

export default () => {
  const options: { providers: ProderT } = {
    providers: {
      google: {
        ...Google,
        redirectUri:
          import.meta.env.VITE_GOOGLE_CLIENT_REDIRECT ?? `http://localhost:3000/social/google`,
        clientId:
          import.meta.env.VITE_GOOGLE_CLIENT_ID ??
          '606901080404-vjc1lu4f8ctbqjme3ogiikncrp6o73lp.apps.googleusercontent.com',
      },
      microsoft: {
        ...microsoftProvider,
        redirectUri:
          import.meta.env.VITE_MICROSOFT_CLIENT_REDIRECT ??
          `http://localhost:3000/social/microsoft`,
        clientId: import.meta.env.VITE_MICROSOFT_CLIENT_ID ?? '649097e4-7a0d-4e57-a32a-c39d6ed93b63',
      },
    },
  }

  const social = new UniversalSocialauth(axios as any, options)

  const socialOauth = async (provider: string) =>
    await social.authenticate(provider, options.providers[provider] as ProderT)

  return {
    social,
    socialOauth,
  }
}
